import script from "./ResearchToolsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResearchToolsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ResearchToolsModal.vue?vue&type=style&index=0&id=f5d7d3f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5d7d3f2"]])

export default __exports__